export default __webpack_public_path__ + "static/media/footer-img-5.55f40baa.png";